module.exports = __webpack_public_path__ + "static/media/GMA-S2100-4AER_OR02_wristshot.9a40dd93.jpg";